import { Box, Flex, Heading } from '@chakra-ui/react';
import { ServiceQuery } from '@src/generated/graphql';
import { DeepExtractTypeSkipArrays } from '@src/types/extract-types';

const ServiceItem: React.FC<
  DeepExtractTypeSkipArrays<ServiceQuery, ['allServices', 'serviceItems']>
> = ({ backgroundImage, subtitle, title }) => {
  return (
    <Flex
      direction="column"
      justifyContent="flex-start"
      alignItems="center"
      backgroundImage={backgroundImage?.asset?.url ?? ''}
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      padding="75px 34px"
    >
      <Heading
        as="h2"
        color="white"
        fontSize="3xl"
        fontFamily="montserrat"
        fontWeight="bold"
        textAlign="center"
      >
        {title}
      </Heading>
      <Box
        w="33px"
        borderBottomColor="primary"
        borderBottomStyle="solid"
        borderBottomWidth="2px"
        my="30px"
      />
      <Heading
        as="h3"
        fontSize="lg"
        color="white"
        fontFamily="montserrat"
        fontWeight="normal"
        textAlign="center"
        lineHeight="27px"
      >
        {subtitle}
      </Heading>
    </Flex>
  );
};

export default ServiceItem;
